import { Component } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR, } from '@angular/forms';
import SensorMetricKindEnum = SensorItemDto.SensorMetricKindEnum;
import { SensorItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-sensor-metric-kind-select',
  templateUrl: './sensor-metric-kind-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SensorMetricKindSelectComponent,
      multi: true,
    },
  ],
})
export class SensorMetricKindSelectComponent extends AbstractFormControl<SensorMetricKindEnum> {
  readonly values = Object.values(SensorMetricKindEnum);

  placeholder = 'Metrik Typ auswählen';
}
